import React from 'react';

import Main from 'layouts/Main';
import Container from 'components/Container';
import {
  FullScreenHeroWithImageSlider,
  SimpleCentered,
  FeaturesWithMobileScreenshot,
  FeaturesWithMobileScreenshot2,
  FeaturesWithMobileScreenshot3,
  FeaturesWithMobileScreenshot4,
  SimpleCentered2,
  //   FAQ,
} from './components';
import dashboard from '/public/images/platform/dashboard.png';
import { useTranslations } from 'next-intl';

const GlobalVisa = (): JSX.Element => {
  const t = useTranslations('GlobalExpansion');

  return (
    <Main colorInvert={false}>
      <Container id="FullScreenHeroWithImageSlider">
        <FullScreenHeroWithImageSlider />
      </Container>
      <Container id="SimpleCentered" data-aos="fade-up">
        <SimpleCentered />
      </Container>
      <Container id="FeaturesWithMobileScreenshot" data-aos="fade-up">
        <FeaturesWithMobileScreenshot />
      </Container>
      <Container id="FeaturesWithMobileScreenshot2" data-aos="fade-up">
        <FeaturesWithMobileScreenshot2 />
      </Container>
      <Container id="FeaturesWithMobileScreenshot3" data-aos="fade-up">
        <FeaturesWithMobileScreenshot3 />
      </Container>
      <Container id="FeaturesWithMobileScreenshot4" data-aos="fade-up">
        <FeaturesWithMobileScreenshot4 />
      </Container>
      <Container id="SimpleCentered2" data-aos="fade-up">
        <SimpleCentered2 />
      </Container>
      {/* 
      <Container id="FAQ" data-aos="fade-up">
        <FAQ />
      </Container> */}
    </Main>
  );
};

export default GlobalVisa;
